












































































































import { AddressLookupApi } from '@/api/address-lookup';
import loading from '@/components/loading.vue';
import { Address } from '@/shared/address';
import { ClientAccountAddress } from '@/shared/clients/client-account-address';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';

const addressLookupApi = new AddressLookupApi();

@Component({
    components: {
        loading,
    },
})
export default class AddressWithLookup extends Vue {
    @Inject('$validator') public $validator!: Validator;

    @Prop({ required: true }) private address!: ClientAccountAddress;
    @Prop({ required: false, default: false }) private allowForeignAddress!: boolean;
    @Prop({ required: false, default: true }) private required!: boolean;
    @Prop({ required: false, default: false }) private compact!: boolean;

    private isLoading: boolean = false;
    private showSearchResults: boolean = false;
    private postcodeFilter: string | null = null;
    private addresses: Array<Address> = [];
    private selectedAddress: Address | null = null;

    @Watch('postcodeFilter')
    private onPostcodeFilterChanged(): void {
        this.showSearchResults = false;
    }

    @Watch('selectedAddress')
    private onSelectedAddressChanged(): void {
        if (this.selectedAddress == null) {
            return;
        }

        this.address.addressLine1 = this.selectedAddress.addressLine1;
        this.address.addressLine2 = this.selectedAddress.addressLine2;
        this.address.addressLine3 = this.selectedAddress.addressLine3;
        this.address.town = this.selectedAddress.town;
        this.address.county = this.selectedAddress.county;
        this.address.postcode = this.selectedAddress.postcode;
    }

    private async onSearchAsync(): Promise<void> {
        if (this.postcodeFilter == null || !this.postcodeFilter.length) {
            return;
        }

        try {
            this.isLoading = true;

            this.addresses = await addressLookupApi.getByPostcodeAsync(this.postcodeFilter);
            this.showSearchResults = true;
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not find addresses for '${this.postcodeFilter}'.`, type: 'is-danger' });
            }
        }

        this.isLoading = false;
    }
}
